// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ZRxwDej7jQmhWEib2fVL {
  display: flex;
  flex-direction: column;
  width: 100%;
}
.yM16rWyD4p0tHQWcLe9Q {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.zR31Hz48UgI37NT8Gzu3 {
  display: flex;
  position: relative;
  width: 100%;
  max-width: 1218px;
  overflow: hidden;
  justify-content: center;
  align-self: center;
  contain: layout style;
}
.KnJ77XCy76YcEfQXh7Oy {
  --carousel-inset: calc(50vw - 222px);
  display: flex;
  gap: 0;
  overflow-x: auto;
  overflow-y: visible;
  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
  -ms-overflow-style: none;
  overscroll-behavior-x: contain;
  overscroll-behavior-y: auto;
  justify-content: flex-start;
  align-items: center;
  /* Same as tournaments - mandatory snap */
  scroll-snap-type: x mandatory;
}
.KnJ77XCy76YcEfQXh7Oy::-webkit-scrollbar {
  display: none;
}
/* Spacer pseudo-elements replace padding-left / padding-right so that
   iOS Safari (WebKit) includes the trailing space in the scrollable area.
   WebKit ignores trailing *padding* when computing scroll extent, which
   prevents the last cards from snapping to center. Real flex items are
   always counted. */
.KnJ77XCy76YcEfQXh7Oy::before,
.KnJ77XCy76YcEfQXh7Oy::after {
  content: '';
  flex-shrink: 0;
  min-width: var(--carousel-inset);
  /* Give the spacers a real height. With align-items: center they would
     otherwise be 0px tall, and Firefox excludes a trailing zero-height flex
     item from the scrollable overflow region — so the ::after spacer is
     ignored and the LAST card has no room to scroll to center (width
     independent, Firefox only). Stretching to full height makes Firefox
     count it like Chrome/WebKit already do. */
  align-self: stretch;
}
/* Desktop landscape */
@media (min-width: 1367px) and (orientation: landscape) {
  .KnJ77XCy76YcEfQXh7Oy {
    --carousel-inset: calc(1218px - 222px);
  }
}
/* Small mobile: Adjust for very small screens */
@media (max-width: 1024px),(min-width: 768px) and (max-width: 1024px) and (orientation: landscape),(orientation: portrait) {
  .KnJ77XCy76YcEfQXh7Oy {
    --carousel-inset: calc(50vw - 150px);
    gap: 0;
  }
  .KnJ77XCy76YcEfQXh7Oy[data-has-many="true"][data-view="single"][data-collapsed='true'] {
    --carousel-inset: calc(50vw - 170px);
  }
}
/* Sub-374px (officially not supported resolution): narrower devices need a smaller collapsed single card to avoid overflow */
@media (max-width: 374px) and (orientation: portrait) {
  .KnJ77XCy76YcEfQXh7Oy[data-has-many="true"][data-view="single"][data-collapsed='true'] {
    --carousel-inset: calc(50vw - 155px);
  }
}
/* Carousel Item - Stable wrapper for scroll calculations */
.x1fSPD3YZAtqUTEww7KQ {
  flex-shrink: 0;
  position: relative;
  /* Same as tournaments - center snap with always stop */
  scroll-snap-align: center;
  scroll-snap-stop: always;
}
/* Mobile campaign card sizes */
@media (max-width: 1024px),(min-width: 768px) and (max-width: 1024px) and (orientation: landscape),(orientation: portrait) {
  .x1fSPD3YZAtqUTEww7KQ[data-has-many="true"][data-view="single"][data-collapsed='true'] {
    width: var(--campaign-card-has-many-single-collapsed-width-mobile);
    min-width: var(--campaign-card-has-many-single-collapsed-width-mobile);
  }
}
/* Card Content - Only GPU-compositable properties (transform, opacity) in the transition */
.y3nBvUy0gnENeDLlVUNQ {
  position: relative;
  transition: transform var(--campaign-transition-fast), opacity var(--campaign-transition-fast);
  border-radius: 12px;
  will-change: transform, opacity;
}
/*
 * Darkening overlay — replaces the animated filter: brightness() which forced
 * full re-rasterization of the card subtree on every frame (the root cause of
 * ~20 fps on Android).  A black ::after that transitions opacity is fully
 * GPU-compositable and produces an identical visual result:
 *   brightness(0.6)  ≡  black overlay @ opacity 0.4   (color × 0.6)
 *   brightness(0.5)  ≡  black overlay @ opacity 0.5   (color × 0.5)
 *   brightness(0.8)  ≡  black overlay @ opacity 0.2   (color × 0.8)
 */
.y3nBvUy0gnENeDLlVUNQ::after {
  content: '';
  position: absolute;
  inset: 0;
  background: black;
  opacity: 0;
  transition: opacity var(--campaign-transition-fast);
  will-change: opacity;
  pointer-events: none;
  z-index: 1;
  border-radius: inherit;
}
/* Inactive card styling */
.y3nBvUy0gnENeDLlVUNQ[data-active="false"] {
  transform: scale(0.8);
  filter: saturate(0.7);
  opacity: 0.8;
}
.y3nBvUy0gnENeDLlVUNQ[data-active="false"]::after {
  opacity: 0.4;
  /* equivalent to brightness(0.6) */
}
/* Cards on the left side move right, cards on the right side move left */
.y3nBvUy0gnENeDLlVUNQ[data-active="false"][data-side="left"] {
  transform: scale(0.8) translateX(30px);
}
.y3nBvUy0gnENeDLlVUNQ[data-active="false"][data-side="right"] {
  transform: scale(0.8) translateX(-30px);
}
/* Hide distant carousel items - max 3 visible campaigns at once */
.y3nBvUy0gnENeDLlVUNQ[data-active="false"][data-side="distant"] {
  opacity: 0;
  visibility: hidden;
}
.y3nBvUy0gnENeDLlVUNQ[data-active="true"] {
  transform: scale(1) translateX(0);
  opacity: 1;
}
/* Hover effects */
.y3nBvUy0gnENeDLlVUNQ[data-active="false"][data-side="left"]:hover {
  transform: scale(0.83) translateX(30px) !important;
  filter: saturate(0.85) !important;
  opacity: 0.9 !important;
}
.y3nBvUy0gnENeDLlVUNQ[data-active="false"][data-side="left"]:hover::after {
  opacity: 0.2 !important;
  /* equivalent to brightness(0.8) */
}
.y3nBvUy0gnENeDLlVUNQ[data-active="false"][data-side="right"]:hover {
  transform: scale(0.83) translateX(-30px) !important;
  filter: saturate(0.85) !important;
  opacity: 0.9 !important;
}
.y3nBvUy0gnENeDLlVUNQ[data-active="false"][data-side="right"]:hover::after {
  opacity: 0.2 !important;
  /* equivalent to brightness(0.8) */
}
.y3nBvUy0gnENeDLlVUNQ[data-active="true"]:hover {
  transform: scale(1) translateX(0) !important;
  filter: brightness(1.05) saturate(1.1) !important;
  opacity: 1 !important;
}
/* Mobile adjustments */
@media (max-width: 1024px),(min-width: 768px) and (max-width: 1024px) and (orientation: landscape),(orientation: portrait) {
  .y3nBvUy0gnENeDLlVUNQ[data-active="false"] {
    filter: saturate(0.6);
    border-radius: 10px;
  }
  .y3nBvUy0gnENeDLlVUNQ[data-active="false"]::after {
    opacity: 0.5;
    /* equivalent to brightness(0.5) */
  }
  /* adjust the translate values so the cards don't overlap */
  .y3nBvUy0gnENeDLlVUNQ[data-active="false"][data-side="left"]:hover {
    transform: scale(0.84) translateX(22px) !important;
  }
  .y3nBvUy0gnENeDLlVUNQ[data-active="false"][data-side="right"]:hover {
    transform: scale(0.84) translateX(-22px) !important;
  }
  .y3nBvUy0gnENeDLlVUNQ[data-active="true"]:hover {
    transform: scale(1) translateX(0) !important;
  }
}
/* Performance: keep containment but drop static will-change — layers are
   promoted dynamically by useCollapseAnimation only when needed. */
.KnJ77XCy76YcEfQXh7Oy {
  contain: style;
}
.y3nBvUy0gnENeDLlVUNQ {
  contain: layout style;
}
/* During collapse/expand, disable filter on inactive cards on ALL devices.
   filter: saturate() forces full re-rasterization of the card subtree on
   every frame while the card height is changing. */
.KnJ77XCy76YcEfQXh7Oy[data-animating="true"] .y3nBvUy0gnENeDLlVUNQ[data-active="false"] {
  filter: none;
}
/* Off-screen cards: skip all transitions so they snap to the new state
   instantly instead of animating where nobody can see them. */
.x1fSPD3YZAtqUTEww7KQ[data-offscreen="true"] .y3nBvUy0gnENeDLlVUNQ {
  transition: none !important;
  animation: none !important;
}
.x1fSPD3YZAtqUTEww7KQ[data-offscreen="true"] .y3nBvUy0gnENeDLlVUNQ::after {
  transition: none !important;
  animation: none !important;
}
/* Accessibility */
@media (prefers-reduced-motion: reduce) {
  .KnJ77XCy76YcEfQXh7Oy {
    scroll-behavior: auto;
  }
  .y3nBvUy0gnENeDLlVUNQ {
    transition: none;
  }
  .y3nBvUy0gnENeDLlVUNQ::after {
    transition: none;
  }
}
/* Focus styles for accessibility */
.x1fSPD3YZAtqUTEww7KQ:focus-within {
  outline: 2px solid var(--campaign-color-primary-light);
  outline-offset: 4px;
  border-radius: var(--campaign-border-radius-xl);
}
/* Stretch down slightly past resting position, then settle back — like gravity pulling a blind */
@keyframes oLbi4eGXtDvKhgcnNDCK {
  0% {
    transform: translateY(0);
  }
  45% {
    transform: translateY(6px);
  }
  100% {
    transform: translateY(0);
  }
}
.MaA3eChAR7ZlFM7WQBZp {
  width: 100%;
  max-width: 1218px;
  position: relative;
  height: 45px;
  background: var(--campaign-gradient-glow-box);
  border-bottom: 1px solid var(--campaign-color-border, var(--campaign-color-primary));
  border-bottom-left-radius: var(--campaign-border-radius-lg);
  border-bottom-right-radius: var(--campaign-border-radius-lg);
  align-self: center;
  margin-top: -20px;
  pointer-events: none;
}
.MaA3eChAR7ZlFM7WQBZp[data-stretch="true"] {
  animation: oLbi4eGXtDvKhgcnNDCK 0.5s cubic-bezier(0.22, 1, 0.36, 1);
}
.zR31Hz48UgI37NT8Gzu3[data-stretch="true"] {
  animation: oLbi4eGXtDvKhgcnNDCK 0.5s cubic-bezier(0.22, 1, 0.36, 1);
}
@media (min-width: 1025px) and (orientation: landscape) {
  .MaA3eChAR7ZlFM7WQBZp[data-has-many='true'][data-collapsed='true'] {
    margin-top: -32px;
  }
}
.MArCAZySYtKy3kN_70fY {
  position: relative;
  width: 572px;
  height: 91px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-size: cover;
  margin: -5px auto 9px;
  transform: scale(1.08);
  /* padding-top: 5px; */
}
.M9Zh22kjnw9xW5wNei_h {
  text-align: center;
  -webkit-text-stroke-width: 0.6px;
  -webkit-text-stroke-color: var(--campaign-color-text-gold-stroke);
  font-family: "Futura PT";
  font-size: 24px;
  font-weight: 700;
  line-height: 8px;
  padding-block: 4px;
  letter-spacing: 7.5px;
  text-transform: uppercase;
  background-image: var(--campaign-gradient-gold-text);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
@media (max-width: 1024px),(min-width: 768px) and (max-width: 1024px) and (orientation: landscape),(orientation: portrait) {
  .MaA3eChAR7ZlFM7WQBZp {
    width: 100%;
    height: 30px;
    margin-top: -13px;
  }
  .MArCAZySYtKy3kN_70fY {
    width: 380px;
    height: 61px;
    margin-bottom: 5px;
  }
  /* Budget the prize-pool amount is scaled to fit inside the topper (read in PrizeFundCampaign).
     Keep it in step with the topper width above — same reason as the collapsed card. Part of the
     --campaign-prize-scale-budget-* family (see the card one in campaign-card-variables.module.css). */
  :root {
    --campaign-prize-scale-budget-topper-mobile: 200px;
  }
  .M9Zh22kjnw9xW5wNei_h {
    font-size: 16px;
    letter-spacing: 5.5px;
  }
}
@media (max-width: 374px) {
  .MArCAZySYtKy3kN_70fY {
    width: 336px;
    height: 54px;
  }
  :root {
    --campaign-prize-scale-budget-topper-mobile: 156px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/features/campaigns/components/defaults/CampaignsCarousel/css/CampaignsCarousel.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,oCAAoC;EACpC,aAAa;EACb,MAAM;EACN,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,iCAAiC;EACjC,qBAAqB;EACrB,wBAAwB;EACxB,8BAA8B;EAC9B,2BAA2B;EAC3B,2BAA2B;EAC3B,mBAAmB;EACnB,yCAAyC;EACzC,6BAA6B;AAC/B;AACA;EACE,aAAa;AACf;AACA;;;;oBAIoB;AACpB;;EAEE,WAAW;EACX,cAAc;EACd,gCAAgC;EAChC;;;;;8CAK4C;EAC5C,mBAAmB;AACrB;AACA,sBAAsB;AACtB;EACE;IACE,sCAAsC;EACxC;AACF;AACA,gDAAgD;AAChD;EACE;IACE,oCAAoC;IACpC,MAAM;EACR;EACA;IACE,oCAAoC;EACtC;AACF;AACA,6HAA6H;AAC7H;EACE;IACE,oCAAoC;EACtC;AACF;AACA,2DAA2D;AAC3D;EACE,cAAc;EACd,kBAAkB;EAClB,uDAAuD;EACvD,yBAAyB;EACzB,wBAAwB;AAC1B;AACA,+BAA+B;AAC/B;EACE;IACE,kEAAkE;IAClE,sEAAsE;EACxE;AACF;AACA,2FAA2F;AAC3F;EACE,kBAAkB;EAClB,8FAA8F;EAC9F,mBAAmB;EACnB,+BAA+B;AACjC;AACA;;;;;;;;EAQE;AACF;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,iBAAiB;EACjB,UAAU;EACV,mDAAmD;EACnD,oBAAoB;EACpB,oBAAoB;EACpB,UAAU;EACV,sBAAsB;AACxB;AACA,0BAA0B;AAC1B;EACE,qBAAqB;EACrB,qBAAqB;EACrB,YAAY;AACd;AACA;EACE,YAAY;EACZ,kCAAkC;AACpC;AACA,yEAAyE;AACzE;EACE,sCAAsC;AACxC;AACA;EACE,uCAAuC;AACzC;AACA,kEAAkE;AAClE;EACE,UAAU;EACV,kBAAkB;AACpB;AACA;EACE,iCAAiC;EACjC,UAAU;AACZ;AACA,kBAAkB;AAClB;EACE,kDAAkD;EAClD,iCAAiC;EACjC,uBAAuB;AACzB;AACA;EACE,uBAAuB;EACvB,kCAAkC;AACpC;AACA;EACE,mDAAmD;EACnD,iCAAiC;EACjC,uBAAuB;AACzB;AACA;EACE,uBAAuB;EACvB,kCAAkC;AACpC;AACA;EACE,4CAA4C;EAC5C,iDAAiD;EACjD,qBAAqB;AACvB;AACA,uBAAuB;AACvB;EACE;IACE,qBAAqB;IACrB,mBAAmB;EACrB;EACA;IACE,YAAY;IACZ,kCAAkC;EACpC;EACA,2DAA2D;EAC3D;IACE,kDAAkD;EACpD;EACA;IACE,mDAAmD;EACrD;EACA;IACE,4CAA4C;EAC9C;AACF;AACA;mEACmE;AACnE;EACE,cAAc;AAChB;AACA;EACE,qBAAqB;AACvB;AACA;;mDAEmD;AACnD;EACE,YAAY;AACd;AACA;8DAC8D;AAC9D;EACE,2BAA2B;EAC3B,0BAA0B;AAC5B;AACA;EACE,2BAA2B;EAC3B,0BAA0B;AAC5B;AACA,kBAAkB;AAClB;EACE;IACE,qBAAqB;EACvB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;AACF;AACA,mCAAmC;AACnC;EACE,sDAAsD;EACtD,mBAAmB;EACnB,+CAA+C;AACjD;AACA,iGAAiG;AACjG;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,wBAAwB;EAC1B;AACF;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,6CAA6C;EAC7C,oFAAoF;EACpF,2DAA2D;EAC3D,4DAA4D;EAC5D,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,mEAA6D;AAC/D;AACA;EACE,mEAA6D;AAC/D;AACA;EACE;IACE,iBAAiB;EACnB;AACF;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,qBAAqB;EACrB,sBAAsB;EACtB,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,iEAAiE;EACjE,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,yBAAyB;EACzB,oDAAoD;EACpD,qBAAqB;EACrB,6BAA6B;EAC7B,oCAAoC;AACtC;AACA;EACE;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;EACA;IACE,YAAY;IACZ,YAAY;IACZ,kBAAkB;EACpB;EACA;;uGAEqG;EACrG;IACE,kDAAkD;EACpD;EACA;IACE,eAAe;IACf,qBAAqB;EACvB;AACF;AACA;EACE;IACE,YAAY;IACZ,YAAY;EACd;EACA;IACE,kDAAkD;EACpD;AACF","sourcesContent":[".carouselContainer {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n}\n.carouselHeader {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n.carouselWrapper {\n  display: flex;\n  position: relative;\n  width: 100%;\n  max-width: 1218px;\n  overflow: hidden;\n  justify-content: center;\n  align-self: center;\n  contain: layout style;\n}\n.carouselScroll {\n  --carousel-inset: calc(50vw - 222px);\n  display: flex;\n  gap: 0;\n  overflow-x: auto;\n  overflow-y: visible;\n  scroll-behavior: smooth;\n  -webkit-overflow-scrolling: touch;\n  scrollbar-width: none;\n  -ms-overflow-style: none;\n  overscroll-behavior-x: contain;\n  overscroll-behavior-y: auto;\n  justify-content: flex-start;\n  align-items: center;\n  /* Same as tournaments - mandatory snap */\n  scroll-snap-type: x mandatory;\n}\n.carouselScroll::-webkit-scrollbar {\n  display: none;\n}\n/* Spacer pseudo-elements replace padding-left / padding-right so that\n   iOS Safari (WebKit) includes the trailing space in the scrollable area.\n   WebKit ignores trailing *padding* when computing scroll extent, which\n   prevents the last cards from snapping to center. Real flex items are\n   always counted. */\n.carouselScroll::before,\n.carouselScroll::after {\n  content: '';\n  flex-shrink: 0;\n  min-width: var(--carousel-inset);\n  /* Give the spacers a real height. With align-items: center they would\n     otherwise be 0px tall, and Firefox excludes a trailing zero-height flex\n     item from the scrollable overflow region — so the ::after spacer is\n     ignored and the LAST card has no room to scroll to center (width\n     independent, Firefox only). Stretching to full height makes Firefox\n     count it like Chrome/WebKit already do. */\n  align-self: stretch;\n}\n/* Desktop landscape */\n@media (min-width: 1367px) and (orientation: landscape) {\n  .carouselScroll {\n    --carousel-inset: calc(1218px - 222px);\n  }\n}\n/* Small mobile: Adjust for very small screens */\n@media (--campaign-mobile) {\n  .carouselScroll {\n    --carousel-inset: calc(50vw - 150px);\n    gap: 0;\n  }\n  .carouselScroll[data-has-many=\"true\"][data-view=\"single\"][data-collapsed='true'] {\n    --carousel-inset: calc(50vw - 170px);\n  }\n}\n/* Sub-374px (officially not supported resolution): narrower devices need a smaller collapsed single card to avoid overflow */\n@media (--campaign-mobile-narrow) {\n  .carouselScroll[data-has-many=\"true\"][data-view=\"single\"][data-collapsed='true'] {\n    --carousel-inset: calc(50vw - 155px);\n  }\n}\n/* Carousel Item - Stable wrapper for scroll calculations */\n.carouselItem {\n  flex-shrink: 0;\n  position: relative;\n  /* Same as tournaments - center snap with always stop */\n  scroll-snap-align: center;\n  scroll-snap-stop: always;\n}\n/* Mobile campaign card sizes */\n@media (--campaign-mobile) {\n  .carouselItem[data-has-many=\"true\"][data-view=\"single\"][data-collapsed='true'] {\n    width: var(--campaign-card-has-many-single-collapsed-width-mobile);\n    min-width: var(--campaign-card-has-many-single-collapsed-width-mobile);\n  }\n}\n/* Card Content - Only GPU-compositable properties (transform, opacity) in the transition */\n.cardContent {\n  position: relative;\n  transition: transform var(--campaign-transition-fast), opacity var(--campaign-transition-fast);\n  border-radius: 12px;\n  will-change: transform, opacity;\n}\n/*\n * Darkening overlay — replaces the animated filter: brightness() which forced\n * full re-rasterization of the card subtree on every frame (the root cause of\n * ~20 fps on Android).  A black ::after that transitions opacity is fully\n * GPU-compositable and produces an identical visual result:\n *   brightness(0.6)  ≡  black overlay @ opacity 0.4   (color × 0.6)\n *   brightness(0.5)  ≡  black overlay @ opacity 0.5   (color × 0.5)\n *   brightness(0.8)  ≡  black overlay @ opacity 0.2   (color × 0.8)\n */\n.cardContent::after {\n  content: '';\n  position: absolute;\n  inset: 0;\n  background: black;\n  opacity: 0;\n  transition: opacity var(--campaign-transition-fast);\n  will-change: opacity;\n  pointer-events: none;\n  z-index: 1;\n  border-radius: inherit;\n}\n/* Inactive card styling */\n.cardContent[data-active=\"false\"] {\n  transform: scale(0.8);\n  filter: saturate(0.7);\n  opacity: 0.8;\n}\n.cardContent[data-active=\"false\"]::after {\n  opacity: 0.4;\n  /* equivalent to brightness(0.6) */\n}\n/* Cards on the left side move right, cards on the right side move left */\n.cardContent[data-active=\"false\"][data-side=\"left\"] {\n  transform: scale(0.8) translateX(30px);\n}\n.cardContent[data-active=\"false\"][data-side=\"right\"] {\n  transform: scale(0.8) translateX(-30px);\n}\n/* Hide distant carousel items - max 3 visible campaigns at once */\n.cardContent[data-active=\"false\"][data-side=\"distant\"] {\n  opacity: 0;\n  visibility: hidden;\n}\n.cardContent[data-active=\"true\"] {\n  transform: scale(1) translateX(0);\n  opacity: 1;\n}\n/* Hover effects */\n.cardContent[data-active=\"false\"][data-side=\"left\"]:hover {\n  transform: scale(0.83) translateX(30px) !important;\n  filter: saturate(0.85) !important;\n  opacity: 0.9 !important;\n}\n.cardContent[data-active=\"false\"][data-side=\"left\"]:hover::after {\n  opacity: 0.2 !important;\n  /* equivalent to brightness(0.8) */\n}\n.cardContent[data-active=\"false\"][data-side=\"right\"]:hover {\n  transform: scale(0.83) translateX(-30px) !important;\n  filter: saturate(0.85) !important;\n  opacity: 0.9 !important;\n}\n.cardContent[data-active=\"false\"][data-side=\"right\"]:hover::after {\n  opacity: 0.2 !important;\n  /* equivalent to brightness(0.8) */\n}\n.cardContent[data-active=\"true\"]:hover {\n  transform: scale(1) translateX(0) !important;\n  filter: brightness(1.05) saturate(1.1) !important;\n  opacity: 1 !important;\n}\n/* Mobile adjustments */\n@media (--campaign-mobile) {\n  .cardContent[data-active=\"false\"] {\n    filter: saturate(0.6);\n    border-radius: 10px;\n  }\n  .cardContent[data-active=\"false\"]::after {\n    opacity: 0.5;\n    /* equivalent to brightness(0.5) */\n  }\n  /* adjust the translate values so the cards don't overlap */\n  .cardContent[data-active=\"false\"][data-side=\"left\"]:hover {\n    transform: scale(0.84) translateX(22px) !important;\n  }\n  .cardContent[data-active=\"false\"][data-side=\"right\"]:hover {\n    transform: scale(0.84) translateX(-22px) !important;\n  }\n  .cardContent[data-active=\"true\"]:hover {\n    transform: scale(1) translateX(0) !important;\n  }\n}\n/* Performance: keep containment but drop static will-change — layers are\n   promoted dynamically by useCollapseAnimation only when needed. */\n.carouselScroll {\n  contain: style;\n}\n.cardContent {\n  contain: layout style;\n}\n/* During collapse/expand, disable filter on inactive cards on ALL devices.\n   filter: saturate() forces full re-rasterization of the card subtree on\n   every frame while the card height is changing. */\n.carouselScroll[data-animating=\"true\"] .cardContent[data-active=\"false\"] {\n  filter: none;\n}\n/* Off-screen cards: skip all transitions so they snap to the new state\n   instantly instead of animating where nobody can see them. */\n.carouselItem[data-offscreen=\"true\"] .cardContent {\n  transition: none !important;\n  animation: none !important;\n}\n.carouselItem[data-offscreen=\"true\"] .cardContent::after {\n  transition: none !important;\n  animation: none !important;\n}\n/* Accessibility */\n@media (prefers-reduced-motion: reduce) {\n  .carouselScroll {\n    scroll-behavior: auto;\n  }\n  .cardContent {\n    transition: none;\n  }\n  .cardContent::after {\n    transition: none;\n  }\n}\n/* Focus styles for accessibility */\n.carouselItem:focus-within {\n  outline: 2px solid var(--campaign-color-primary-light);\n  outline-offset: 4px;\n  border-radius: var(--campaign-border-radius-xl);\n}\n/* Stretch down slightly past resting position, then settle back — like gravity pulling a blind */\n@keyframes glowBoxStretch {\n  0% {\n    transform: translateY(0);\n  }\n  45% {\n    transform: translateY(6px);\n  }\n  100% {\n    transform: translateY(0);\n  }\n}\n.glowBox {\n  width: 100%;\n  max-width: 1218px;\n  position: relative;\n  height: 45px;\n  background: var(--campaign-gradient-glow-box);\n  border-bottom: 1px solid var(--campaign-color-border, var(--campaign-color-primary));\n  border-bottom-left-radius: var(--campaign-border-radius-lg);\n  border-bottom-right-radius: var(--campaign-border-radius-lg);\n  align-self: center;\n  margin-top: -20px;\n  pointer-events: none;\n}\n.glowBox[data-stretch=\"true\"] {\n  animation: glowBoxStretch 0.5s cubic-bezier(0.22, 1, 0.36, 1);\n}\n.carouselWrapper[data-stretch=\"true\"] {\n  animation: glowBoxStretch 0.5s cubic-bezier(0.22, 1, 0.36, 1);\n}\n@media (min-width: 1025px) and (orientation: landscape) {\n  .glowBox[data-has-many='true'][data-collapsed='true'] {\n    margin-top: -32px;\n  }\n}\n.carouselTopper {\n  position: relative;\n  width: 572px;\n  height: 91px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  background-size: cover;\n  margin: -5px auto 9px;\n  transform: scale(1.08);\n  /* padding-top: 5px; */\n}\n.carouselTopperTitle {\n  text-align: center;\n  -webkit-text-stroke-width: 0.6px;\n  -webkit-text-stroke-color: var(--campaign-color-text-gold-stroke);\n  font-family: \"Futura PT\";\n  font-size: 24px;\n  font-weight: 700;\n  line-height: 8px;\n  padding-block: 4px;\n  letter-spacing: 7.5px;\n  text-transform: uppercase;\n  background-image: var(--campaign-gradient-gold-text);\n  background-clip: text;\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n}\n@media (--campaign-mobile) {\n  .glowBox {\n    width: 100%;\n    height: 30px;\n    margin-top: -13px;\n  }\n  .carouselTopper {\n    width: 380px;\n    height: 61px;\n    margin-bottom: 5px;\n  }\n  /* Budget the prize-pool amount is scaled to fit inside the topper (read in PrizeFundCampaign).\n     Keep it in step with the topper width above — same reason as the collapsed card. Part of the\n     --campaign-prize-scale-budget-* family (see the card one in campaign-card-variables.module.css). */\n  :root {\n    --campaign-prize-scale-budget-topper-mobile: 200px;\n  }\n  .carouselTopperTitle {\n    font-size: 16px;\n    letter-spacing: 5.5px;\n  }\n}\n@media (max-width: 374px) {\n  .carouselTopper {\n    width: 336px;\n    height: 54px;\n  }\n  :root {\n    --campaign-prize-scale-budget-topper-mobile: 156px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"carouselContainer": `ZRxwDej7jQmhWEib2fVL`,
	"carouselHeader": `yM16rWyD4p0tHQWcLe9Q`,
	"carouselWrapper": `zR31Hz48UgI37NT8Gzu3`,
	"carouselScroll": `KnJ77XCy76YcEfQXh7Oy`,
	"carouselItem": `x1fSPD3YZAtqUTEww7KQ`,
	"cardContent": `y3nBvUy0gnENeDLlVUNQ`,
	"glowBox": `MaA3eChAR7ZlFM7WQBZp`,
	"glowBoxStretch": `oLbi4eGXtDvKhgcnNDCK`,
	"carouselTopper": `MArCAZySYtKy3kN_70fY`,
	"carouselTopperTitle": `M9Zh22kjnw9xW5wNei_h`
};
export default ___CSS_LOADER_EXPORT___;
